import { PipelineRepository } from '@telespot/domain';

export interface ICountStepsForPipelineQuery {
  /**
   * Counts the steps that belong to a given pipeline.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(pipelineId: string): Promise<number>;
}

export class CountStepsForPipelineQuery implements ICountStepsForPipelineQuery {
  constructor(private readonly pipelineRepository: PipelineRepository) {}

  public async execute(pipelineId: string): Promise<number> {
    return this.pipelineRepository.countStepsForPipeline(pipelineId);
  }
}
